<template>
  <base-card class="h-100">
    <div class="py-1 ml-3">
      <base-heading class="title-card mb-4">
        Activity
      </base-heading>
      <!-- <hr style="border-color: #D4D4D4"> deleted by new design -->
      <template v-if="loading">
        <div class="row">
          <base-skeleton
            v-for="n in 6"
            :key="n"
            class="py-4 w-50"
          >
            <div class="d-flex flex-column align-items-center justify-content-between">
              <div
                class="skeleton__item"
                style="width: 100px"
              />
              <div
                class="skeleton__item"
                style="width: 40px"
              />
            </div>
          </base-skeleton>
        </div>
      </template>
      <template v-else>
        <div class="row no-gutters mx-n2 pt-2">
          <div
            v-for="(metric, index) in entries"
            :key="`metric_${index}`"
            :class="`col-6
        ${index % 2 === 0 ? 'b-right pl-2 pr-4' : 'pl-4 pr-2'}
        ${index < 2 ? 'pt-2 pb-4' : index >= (entries.length - 2 + entries.length % 2) ? 'pt-4 pb-2' : 'py-4'}
      ${index < (entries.length - 2 + entries.length%2) ? 'b-bottom' : ''}`"
          >
            <div class="text-center">
              <base-text
                light
                size="m"
                class="mb-1"
              >
                {{ metric.label }}
              </base-text>
              <base-text
                class="value"
                medium
              >
                {{ metric.value }}
              </base-text>
            </div>
          </div>
        </div>
      </template>
    </div>
  </base-card>
</template>
<script>
export default {
  name: 'Activity',
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Activity',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss"
  scoped>
.b-bottom {
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
}

.b-right {
  border-right: solid 1px rgba(0, 0, 0, 0.1);
}

.value {
  font-size: 17px;
}
.title-card {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 19px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
}
</style>
